import store from "../../store";
import { AuthenticationRepository } from ".";
import { Authenticate, IAuthenticationService } from "../../domain/authentication";

export class AuthenticationService implements IAuthenticationService {
  constructor(private readonly _repository: AuthenticationRepository) {
  }

  async login(id: string, password: string): Promise<void> {
    try {
      const result = await this._repository.getAuthentication(id, password);
      this.updateStore(result);
    } catch (e) {
      this.clearStore();
      throw e;
    }
  }

  async logout(): Promise<void> {
    try {
      await this._repository.discardAuthentication();
      this.clearStore();
    } catch (e) {
      this.clearStore();
      throw e;
    }
  }

  private updateStore(source: Authenticate): void {
    store.commit("setToken", source.token);
    console.debug(store.getters.token);
    store.commit("setUser", source.user);
    console.debug(store.getters.user);
    store.commit("setFolderGuid", "");
    console.debug(store.getters.folderGuid);
  }

  private clearStore(): void {
    store.commit("setToken", null);
  }
}
